import React, { Component} from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../Form/ItemList';

@inject('inventoryManufacturerStore')
@observer
class InventoryManufacturer extends Component {
  render() {
    const { inventoryManufacturerStore, children } = this.props;
   
    return (
      <ItemList
        store={inventoryManufacturerStore}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'url', label: 'URL' },
          { key: 'description', label: 'Description' },
          { key: 'address', label: 'Address' },
        ]}
        slug={'inventory/manufacturer'}
        resource={'inventory'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
    );
  }
}

export default InventoryManufacturer;



// WEBPACK FOOTER //
// ./src/components/Inventory/ManufacturerList.js